import { PropTypes } from "prop-types";

import useDeviceDetect from "../../hooks/useDeviceDetect";
import useIsHydrationComplete from "../../hooks/useIsHydrationComplete";

import * as Styles from "./fullScreenVideo/styles.module.scss";

function FullScreenVideo({ content }) {
  const { isMobile } = useDeviceDetect();
  const videoUrl = isMobile ? content?.mobileVideo?.url : content?.desktopVideo?.url;
  const hydrationComplete = useIsHydrationComplete();

  if (!content) {
    return null;
  }

  return (
    <div className={Styles.full_screen_video}>
      {content.title && <h2 className="h2 h2--bold h2--uc">{content?.title}</h2>}
      <div className={Styles.full_screen_video__content}>
        {hydrationComplete && (
          <video
            src={videoUrl}
            autoPlay
            muted
            loop
            playsInline
            style={{ width: "100%", height: "auto" }}
          >
            <track kind="captions" />
            Your browser does not support the video tag.
          </video>
        )}
      </div>
    </div>
  );
}

FullScreenVideo.propTypes = {
  content: PropTypes.shape({
    contentful_id: PropTypes.string,
    title: PropTypes.string,
    autoPlay: PropTypes.bool,
    desktopVideo: PropTypes.shape({
      filename: PropTypes.string,
      url: PropTypes.string,
    }),
    widthRatioDesktop: PropTypes.string,
    mobileVideo: PropTypes.shape({
      filename: PropTypes.string,
      url: PropTypes.string,
    }),
    widthRatioMobile: PropTypes.string,
  }).isRequired,
};

export default FullScreenVideo;
